import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from 'src/app/_service/api-service.service';

@Component({
  selector: 'app-zone-report',
  templateUrl: './zone-report.component.html',
  styleUrls: ['./zone-report.component.scss']
})
export class ZoneReportComponent implements OnInit {
  spinner: boolean;
  customers: any = [];
  dtOptions: any = {};
  tableshow: boolean = false;
  regob:any;
  dashboardcarddata: any;
  district_list: any[] = this.ApiService.all_districts_zone;
  constructor(
              public ApiService: ApiServiceService,
              private spinnerService: NgxSpinnerService,
              private sanitizer: DomSanitizer) { }



  ngOnInit(): void {
     this.getdata();
      this.showSpinner();
      this.dtOptions = {
        pagingType: 'full_numbers',
        order: [[0, 'asc']],
        dom: 'lBfrtip',
          buttons: [{
            extend: 'print',
            title:'<h4 style="text-align: center; font-size: 24px;font-weight: bold;">ZONE-WISE BEARER REPORT</h4>',
            exportOptions: {stripHtml: false },
            footer: true,
            customize: function ( win ) {

                $(win.document.body)
                    .css( 'font-size', '10pt' );

                $(win.document.body).find( 'table' )
                    .addClass( 'compact' )
                    .css( 'font-size', 'inherit' );
                    const footer = win.document.createElement('div'); // Create a new footer element    
                    footer.innerHTML = '<h4 style="text-align: center;">DMK Engineering Wing</h4>';
                    win.document.body.appendChild(footer);
            }
        }],
      };
      this.addPrintStyles();
  }
  private addPrintStyles() {
    const head = document.getElementsByTagName('body')[0];
    const style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = `
      @media print {
        body * {
          visibility: visible;
        }
      }
    `;

    head.appendChild(style);
  }


  getdata() {
    this.spinner = true;
    this.ApiService.zone_report(this.district_list[0]).subscribe((data) => {
      console.log(this.district_list[0]);
      for (const prop in data) {
        for(const ob in data[prop]){

          let objectURL = 'data:image/jpeg;base64,' +  data[prop][ob].image_data;
          //console.log(objectURL)
          data[prop][ob]["image_encode"] = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        }
        this.customers.push(data[prop]);
      }

      this.tableshow = true;
      this.spinner = false;
    });
  }
  public showSpinner(): void {
    //this.spinner = true;
    this.spinnerService.show();
  }

  DistrictChange(event: any) {
    this.customers = [];
    const selectedValue = event.target.value;
    console.log(selectedValue )
    this.spinner = true;
    this.tableshow = false;
    this.ApiService.zone_report(selectedValue).subscribe((data) => {
      this.spinner = false;
      console.log(data);
      for (const prop in data) {
        for(const ob in data[prop]){

          let objectURL = 'data:image/jpeg;base64,' +  data[prop][ob].image_data;
          //console.log(objectURL)
          data[prop][ob]["image_encode"] = this.sanitizer.bypassSecurityTrustUrl(objectURL);
          
        }
        this.customers.push(data[prop]);
      }

      this.tableshow = true;
    });
  }


}
